export const sortingOrders = {
  sortOrders: [
    {
      kod: "ASC",
      nazwa: "rosnąco",
    },
    {
      kod: "DESC",
      nazwa: "malejąco",
    },
  ]
};
